import { MdDownload } from 'react-icons/md';
import type { CsvProblem, WhatsappTemplate } from '../types/whatsapp';
import { downloadRecipientSheet } from '../utils/downloadRecipientSheet';
import CsvDropZone from './CsvDropZone';
import CsvProblemList from './CsvProblemList';

interface RecipientsSectionProps {
  template: WhatsappTemplate | null;
  file: File | null;
  isParsing: boolean;
  problems: CsvProblem[];
  showProblems: boolean;
  strandedCampaignId: string | null;
  onFileSelected: (file: File) => void;
  onFileCleared: () => void;
}

export default function RecipientsSection({
  template,
  file,
  isParsing,
  problems,
  showProblems,
  strandedCampaignId,
  onFileSelected,
  onFileCleared,
}: RecipientsSectionProps) {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <span className="block text-sm font-medium text-gray-700">
          Recipients
        </span>
        <button
          type="button"
          onClick={() => template && downloadRecipientSheet(template)}
          disabled={!template}
          className="flex items-center gap-1 text-sm font-medium text-blue-600 hover:text-blue-700 disabled:cursor-not-allowed disabled:text-gray-400"
        >
          <MdDownload size={16} />
          Download template CSV
        </button>
      </div>

      <CsvDropZone
        file={file}
        isParsing={isParsing}
        onFileSelected={onFileSelected}
        onFileCleared={onFileCleared}
      />

      {showProblems && problems.length > 0 && (
        <CsvProblemList problems={problems} />
      )}

      {strandedCampaignId && (
        <div className="rounded-md bg-red-50 px-4 py-3 text-sm text-red-700">
          The recipients did not finish uploading for comms{' '}
          <span className="font-medium">{strandedCampaignId}</span>. Press Send
          comms again — it reuses the same comms and will not send twice.
        </div>
      )}
    </div>
  );
}
